import React from 'react'
import styled from 'styled-components'
import {Paper} from '@mui/material'
import LoadingIndicator from '../../../shared/UI/LoadingIndicator'

const LoadingIndicatorContainer = styled.div`
  padding-top: 70px;
  padding-bottom: 70px;
`

interface LoadingWrapperProps {
  isLoading: boolean
  children: React.ReactNode
  minHeight?: number
}

function LoadingWrapper({ isLoading, children, minHeight = 400 }: Readonly<LoadingWrapperProps>) {
  if (isLoading) {
    return (
      <Paper elevation={2} sx={{p: 3, minHeight}}>
        <LoadingIndicatorContainer>
          <LoadingIndicator show={isLoading} />
        </LoadingIndicatorContainer>
      </Paper>
    )
  }

  return <>{children}</>
}

export default LoadingWrapper